export default __webpack_public_path__ + "static/media/ic_note.efa300af.svg";